const { REACT_APP_FLAGSMITH_ENV_ID } = process.env

export { REACT_APP_FLAGSMITH_ENV_ID as FLAGSMITH_ENV_ID }
